import React from 'react'

import { Container } from './styles'

interface Props {
  size?: number
  color?: string
}

export const Spinner: React.FC<Props> = (props) => {
  return (
    <Container>
      <svg
        width={props.size || '24'}
        height={props.size || '24'}
        viewBox={`0 0 ${props.size || '24'} ${props.size || '24'}`}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 2V6'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 18V22'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.92999 4.93018L7.75999 7.76018'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.24 16.2402L19.07 19.0702'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2 12H6'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18 12H22'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.92999 19.0702L7.75999 16.2402'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.24 7.76018L19.07 4.93018'
          stroke={props.color || 'black'}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </Container>
  )
}
